import React, { useContext, useEffect } from 'react';

import { ReactComponent as LeftIcon } from '../../../../../resources/img/icons/keyboard_arrow_left.svg';
import { ReactComponent as RightIcon } from '../../../../../resources/img/icons/keyboard_arrow_right.svg';
import { useAnalyticsContext } from '../AnalyticsProvider';
import { AppDataContext } from '../../../../../contexts/appData';

const styles = {
  height: 20,
  width: 20,
  border: '1px solid #DADBDD',
  boxShadow: '0 1.5px 0 0 #DADBDD',
  borderRadius: '5px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: 11,
  color: '#757B8C',
};

export const Actions = ({ onClose }) => {
  const {setProductId, nextProductId, prevProductId} = useAnalyticsContext()
  const { langs } = useContext(AppDataContext);

  const handleKeyDown = (e) => {
    if (e.repeat) return;

    if (e.key === 'Escape') {
      setProductId(null);
      onClose();
    } else if (e.key === 'ArrowLeft' && prevProductId) {
        window.gtag('event', 'navigate_product_analytics', {
          productId: prevProductId,
          direction: 'previous'
        });

        setProductId(Number(prevProductId));
    } else if (e.key === 'ArrowRight' && nextProductId) {
        window.gtag('event', 'navigate_product_analytics', {
          productId: nextProductId,
          direction: 'next'
        });

        setProductId(Number(nextProductId));
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [prevProductId,nextProductId, onClose]);

  return (
    <div className="d-none d-lg-flex justify-content-center gap-24px mt-24px">
      <div className="d-flex gap-12px" onClick={() => {}}>
        <div style={styles}>
          <LeftIcon />
        </div>
        <div style={{ fontSize: 12, color: '#757B8C' }}>{langs?.NM_PreviousProduct}</div>
      </div>
      <div className="d-flex gap-12px" onClick={() => {}}>
        <div style={styles}>
          <RightIcon />
        </div>
        <div style={{ fontSize: 12, color: '#757B8C' }}>{langs?.NM_NextProduct}</div>
      </div>
      <div className="d-flex gap-12px">
        <div className="font-medium" style={{ ...styles, padding: '0 4px', width: 'auto' }}>
          esc
        </div>
        <div style={{ fontSize: 12, color: '#757B8C' }}>{langs?.Disable}</div>
      </div>
    </div>
  );
};
